import { useTranslation } from 'react-i18next';
import {
    Drawer,
} from '@material-ui/core';
import './ProgressSidePanel.scss';
import TitleBar from './TitleBar';
import ProgressSummary from './ProgressSummary';
import CollapsableSteps from './CollapsableSteps';
import { getStepPublishStatusTypeLabel } from '../../Enums/Helpers/LabellingHelper';

/**
 * @param {{
 *   open: boolean,
 *   onClose: () => void,
 *   workplanName: string,
 *   effectiveDate: string,
 *   endDate: string,
 *   isForeverRequestPeriod: boolean,
 *   currentPublishStatusType: PublishStatusType,
 *   currentProgressValue: number,
 *   stepInfo: WorkplanPublishProgress.IStepInfoItem[],
 * }} param0
 */
function ProgressSidePanel({
    open, onClose, workplanName, effectiveDate, endDate, isForeverRequestPeriod, currentPublishStatusType, currentProgressValue, stepInfo,
}) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'manager.bidProfileEdit.bidDashboard.publishProgress' });
    
    const parsedStepInfo = stepInfo.map((x) => ({
        stepLabel: t(`steps.step${x.stepNumber}`),
        statusLabel: getStepPublishStatusTypeLabel(x.stepStatus),
        stepNumber: x.stepNumber,
        stepStatus: x.stepStatus,
        errors: x.errors,
    }));
    return (
        <Drawer
            anchor="right"
            open={open}
            classes={{ paper: 'publishProgressDrawerPaper' }}
        >
            <div>
                <TitleBar onClose={onClose} />
            </div>
            <div className="psp--content">
                <div className="psp-card">
                    <ProgressSummary
                        workplanName={workplanName}
                        effectiveDate={effectiveDate}
                        endDate={endDate}
                        isForeverRequestPeriod={isForeverRequestPeriod}
                        publishStatusType={currentPublishStatusType}
                        progressValue={currentProgressValue}
                    />
                </div>
                <div className="psp-card">
                    <CollapsableSteps
                        stepInfo={parsedStepInfo}
                    />
                </div>
            </div>
        </Drawer>
    );
}

export default ProgressSidePanel;
